import { ErrorBoundary } from './components/ErrorBoundary';
import { LayoutRouter } from './components/LayoutProvider';
import React from 'react';

const App: React.FC = () => {
  return (
    <ErrorBoundary isLayout name="LayoutRouter">
      <LayoutRouter />
    </ErrorBoundary>
  );
};

export default App;
